import React, { useEffect, useRef } from 'react';

import { Loader } from '../../components';
// Prefetch disabled — now handled by the backend.
// import { useContracts } from '../../hooks/useContracts';
// import { getDashboardData } from '../../services/dashboard-service';
import { useTranslation } from '../../utils/translations';

interface AccountSetupProps {
    /** Called once the prefetch has settled (success or failure) so the caller can stop rendering this screen. */
    onDone: () => void;
}

/**
 * Post-login landing screen. Prefetches contracts, open invoices, payment history, and
 * dashboard summary data in parallel so the app has a warm cache before the user lands on
 * the Contracts list. Failures here don't block proceeding — each screen that owns one of
 * these datasets (contracts/index.tsx, dashboard-home.tsx, payments/index.tsx) already
 * retries its own fetch on mount, so a failed prefetch just means that screen fetches fresh
 * when the user gets there instead of reusing a warm result.
 *
 * Rendered directly by App.tsx as plain conditional state (not a route) — navigating to a
 * dedicated URL for this screen raced PostAuthenticatedRoutes' own "/login -> ContractOverview"
 * redirect for already-authenticated users.
 */
const AccountSetup: React.FC<AccountSetupProps> = ({ onDone }) => {
    const { t } = useTranslation();
    // const { fetchContracts } = useContracts();
    const hasStarted = useRef(false);

    useEffect(() => {
        if (hasStarted.current) return;
        hasStarted.current = true;

        // Prefetch disabled — now handled by the backend.
        // const prefetchAndProceed = async () => {
        //     const results = await Promise.allSettled([fetchContracts(true), getDashboardData(false)]);
        //
        //     results.forEach((result, index) => {
        //         if (result.status === 'rejected') {
        //             console.error(`[AccountSetup] Prefetch call ${index} failed:`, result.reason);
        //         }
        //     });
        //
        //     onDone();
        // };
        //
        // prefetchAndProceed();

        onDone();
    }, [onDone]);

    return <Loader message={t('accountSetup.message')} />;
};

export default AccountSetup;
